import { RiskMatrixLabel } from 'types'

export const FALLBACK_CONSEQUENCE_LABELS: RiskMatrixLabel[] = [
  { value: 'Very Low', description: '' },
  { value: 'Low', description: '' },
  { value: 'Med.', description: '' },
  { value: 'High', description: '' },
  { value: 'Very High', description: '' },
]

export const FALLBACK_LIKELIHOOD_LABELS: RiskMatrixLabel[] = [
  { value: 'Rare', description: '' },
  { value: 'Unlikely', description: '' },
  { value: 'Possible', description: '' },
  { value: 'Likely', description: '' },
  { value: 'Almost Certain', description: '' },
]

export const FALLBACK_RISK_MATRIX = [
  ['I', 'I', 'II', 'III', 'III'],
  ['I', 'I', 'II', 'III', 'IV'],
  ['I', 'II', 'III', 'IV', 'IV'],
  ['II', 'III', 'III', 'IV', 'IV'],
  ['II', 'III', 'III', 'IV', 'IV'],
]
